module.exports = __webpack_public_path__ + "media/living_on_a_budget/documents_download-68f14862.png";